import { SHA512 } from "crypto-js";
import { gpapi } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const GlobalPaymentsAPIs = {

    
    PostToken: async function (cancel = false){

        const nonce = (new Date()).toISOString();
        const secret = (SHA512(nonce +""+ process.env.REACT_APP_APP_KEY)).toString();
        const response = await gpapi.request({
            url: '/accesstoken',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-GP-Version": "2021-03-22"
            },
            data: {
                app_id: process.env.REACT_APP_APP_ID,
                nonce: nonce,
                secret: secret,
                grant_type: "client_credentials"
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return response;
    },

    GetLink: async function (token, linkID, cancel = false){

        const response = await gpapi.request({
            url: '/links/' + linkID,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "X-GP-Version": "2021-03-22",
                "Authorization": "Bearer " + token
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return response;
    },

    PostLink: async function (token, postJSON, cancel = false){

        const response = await gpapi.request({
            url: '/links',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-GP-Version": "2021-03-22",
                "Authorization": "Bearer " + token
            },
            data: postJSON,
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return response;
    },
    

    
}
const cancelAPIObject = defineCancelApiObject(GlobalPaymentsAPIs)